import { Injectable } from '@angular/core';
import { ApiService } from './api-service/api.service';
import { HttpContextToken } from '@angular/common/http';

export interface ApiUser {
    id: number;
    [key: string]: any;
}

@Injectable({
    providedIn: 'root',
})
export class ApiUsersRepoService {

    constructor (
        private apiService: ApiService,
    ) { }

    getAll (params?: any, headers?: any, contextToken?: HttpContextToken<boolean>): Promise<any> {
        params = params || {};
        return this.apiService.get<any>('api_users', params, headers, contextToken);
    }

    get (apiUser: ApiUser, params?: any, headers?: any, contextToken?: HttpContextToken<boolean>): Promise<any> {
        params = params || {};
        return this.apiService.get<any>('api_users/' + apiUser.id, params, headers, contextToken);
    }

    create (params?: any): Promise<any> {
        params = params || {};
        return this.apiService.post<any>('api_users', params);
    }

    destroy (apiUser: ApiUser, params?: any): Promise<any> {
        params = params || {};
        return this.apiService.delete<any>('api_users/' + apiUser.id, params);
    }

    revokeToken (apiUser: ApiUser, params?: any): Promise<any> {
        params = params || {};
        return this.apiService.post<any>('api_users/' + apiUser.id + '/revoke_token', params);
    }
}
